module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('heading', {
    attrs: {
      "text": _vm.interview.band,
      "level": 2,
      "font": "oswald",
      "color": "red",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [(_vm.interview.picture) ? _c('figure', [_c('img', {
    attrs: {
      "src": _vm.interview.picture,
      "alt": _vm.interview.picture
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.interview.date) ? _c('div', {
    staticClass: "credits"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('interviews.credits')) + " " + _vm._s(_vm.interview.author))]), _c('br'), _vm._v("\n      " + _vm._s(_vm.$d(new Date(_vm.interview.date), 'short')) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.interview.content)
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3db5c94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/Interview.vue
// module id = 286
// module chunks = 0